import { useLayoutEffect, useRef, useState } from "react";

const useIsOverflow = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => setIsOverflow(el.scrollWidth > el.clientWidth);
    check(); // 초기 체크

    const ro = new ResizeObserver(check);
    ro.observe(el);

    return () => ro.disconnect();
  }, []);

  return { ref, isOverflow };
};

export default useIsOverflow;
